






























































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { SchoolGroup } from '@/models/school-group/school-group';
import moment from 'moment';
import { groupModule } from '@/store/modules/entities/group.module';
import { globalModule } from '@/store/modules/global.module';
import GOptionalData from '@/components/GOptionalData.vue';
import GOptionalIcon from '@/components/GOptionalIcon.vue';
import { GEnum } from '@/constants/enum.defination';

@Component({
  name: 'GClassManagementGroupTable',
  components: { GOptionalIcon, GOptionalData },
  computed: {},
  methods: {},
})
export default class GClassManagementGroupTable extends mixins(GPageBase) {
  studentsGroupTableColumns: any[] = [];
  isNameColumnSortable: boolean = false;
  isRegisteredStudentColumnSortable: boolean = false;
  isCreatedDateColumnSortable: boolean = false;
  isNoteColumnSortable: boolean = false;
  isActionColumnSortable: boolean = false;

  mounted() {
    this.createColumn();
  }

  createColumn(): void {
    this.studentsGroupTableColumns = [this.columnName, this.columnRegisteredStudent, this.columnTag, this.columnNote, this.columnCreatedDate, this.columnAction];
  }

  get schoolGroups(): SchoolGroup[] {
    return groupModule.schoolGroups;
  }

  get isOldSchoolYear(): boolean {
    return globalModule.isOldSchoolYear;
  }

  get columnName(): any {
    return {
      title: this.$t('GROUP_NAME').toString(),
      slot: 'group_name',
      width: '250',
      sortable: this.isNameColumnSortable,
      align: 'center',
    };
  }

  get columnRegisteredStudent(): any {
    return {
      title: this.$t('REGISTERED_COUNT').toString(),
      slot: 'group_person_count',
      width: '100',
      sortable: this.isRegisteredStudentColumnSortable,
      align: 'center',
    };
  }

  get columnTag(): any {
    return {
      title: this.$t('TAG').toString(),
      slot: 'tag',
      align: 'center',
      width: '300',
    };
  }

  get columnNote(): any {
    return {
      title: this.$t('MEMO').toString(),
      slot: 'memo',
      sortable: this.isNoteColumnSortable,
      width: '340',
      align: 'center',
    };
  }

  get columnCreatedDate(): any {
    return {
      title: this.$t('CREATED_DATE').toString(),
      slot: 'createdAt',
      sortable: this.isCreatedDateColumnSortable,
      width: '130',
      align: 'center',
    };
  }

  get columnAction(): any {
    return {
      title: ' ',
      slot: 'action',
      sortable: this.isActionColumnSortable,
      align: 'center',
    };
  }
  handleGoToEditPage(group: SchoolGroup) {
    this.$router.push(`/pages/group-edit/${group.schoolGroupID}`);
  }

  handleDeleteConfirm(group: SchoolGroup) {
    let config = {
      title: this.$t('DELETE_GROUP').toString(),
      content: this.$t('CONFIRM_DELETE_GROUP', {value: group.name}).toString(),
      onOk: () => {
        groupModule.deleteSchoolGroup(group.schoolGroupID).then(() => {
          groupModule.setSchoolGroups(this.schoolGroups.filter((g: SchoolGroup) => g.schoolGroupID !== group.schoolGroupID));
          this.showNotice(GEnum.MessageType.Success, this.$t('DELETE_GROUP').toString(), this.$t('MESSAGE_DELETE_GROUP', {value: group.name}).toString(), 10);
        });
      },
      onCancel: () => {
        return;
      },
    };
    this.$Modal.confirm(config);
  }
}
